/* eslint-disable max-len */
import api from '../../../services/api';

const API_URL = '/api/v1/manager/bidProfile';

/**
 * @returns {Promise<ApiManager.GetAllBidProfilesResponse>}
 */
export const getAllBidProfiles = () => api.get(API_URL);

/**
 * @returns {Promise<ApiManager.GetAllArchivedBidProfilesResponse>}
 */
export const getAllBidProfilesArchived = () => api.get(`${API_URL}/Archive`);

/**
 * @param {string} profileId
 * @param {boolean} isReturnRebid
 * @returns {Promise<ApiManager.GetBidProfileResponse>}
 */
export const getBidProfile = (profileId, isReturnRebid = false) => api.get(`${API_URL}/${profileId}${isReturnRebid ? '?isReturnRebid=true' : ''}`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetBidProfileScheduleItemsResponse>}
 */
export const GetBidProfileScheduleItems = (profileId) => api.get(`${API_URL}/${profileId}/scheduleItems`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetManagementInfosResponse>}
 */
export const getBidProfileManagementInfos = (profileId) => api.get(`${API_URL}/${profileId}/managementInfos`);

/**
 * @param {string} profileId
 * @param {BidProfile.IBidProfileInformationAccordion} biddingInformation
 * @returns {Promise<ApiManager.UpdatedBidProfileResponse>}
 */
export const updateBiddingInformation = (profileId, biddingInformation) => api.put(`${API_URL}/${profileId}/biddingInformation`, biddingInformation);

/**
 * @param {string} profileId
 * @param {any} excelFile
 * @returns {Promise<ApiManager.GetBidProfileScheduleItemsResponse>}
 */
export const UploadExcelScheduleTemplates = (profileId, excelFile) => {
    const bodyFormData = new FormData();
    const configs = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };

    bodyFormData.append('excelFile', excelFile);

    return api.put(`${API_URL}/${profileId}/UploadExcelScheduleTemplates`, bodyFormData, configs);
};

/**
 * @param {string} profileId
 * @param {number[]} selectedIds
 * @returns {Promise<ApiManager.GetBidProfileResponse>}
 */
export const SelectSchedulePatternTemplates = (profileId, selectedIds) => api.put(`${API_URL}/${profileId}/SelectSchedulePatternTemplates`, { SelectedScheduleTemplateItemIds: selectedIds });

/**
 * @param {string} profileId
 * @param {string[]} selectedIds
 * @returns {Promise<ApiManager.GetBidProfileScheduleItemsResponse>}
 */
export const selectWorkplans = (profileId, selectedIds) => api.put(`${API_URL}/${profileId}/SelectWorkplans`, { SelectedWorkplanIds: selectedIds });

/**
 * @param {string} profileId
 * @param {BidProfile.IUpdateEmployeeSelection} employees
 * @returns {Promise<ApiManager.GetBidProfileResponse>}
 */
export const updateEmployeeSelection = (profileId, employees) => api.put(`${API_URL}/${profileId}/employees`, employees);

/**
 * @param {string} profileId
 * @param {ApiManager.ISchedulingAndVisibilityPresentationModel} schedulePeriod
 * @returns {Promise<ApiManager.UpdatedBidProfileResponse>}
 */
export const updateschedulePeriod = (profileId, schedulePeriod) => api.put(`${API_URL}/${profileId}/schedulingAndVisibility`, schedulePeriod);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetBidProfileDraftResponse>}
 */
export const duplicateBidProfile = (profileId) => api.post(`${API_URL}/${profileId}/Duplicate`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetBidProfileDraftResponse>}
 */
export const rebidBidProfile = (profileId) => api.post(`${API_URL}/${profileId}/Rebid`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetManagementInfosResponse>}
 */
export const recalculateAwarding = (profileId) => api.post(`${API_URL}/${profileId}/Award`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetManagementInfosResponse>}
 */
export const recalculateEmployeeRanks = (profileId) => api.post(`${API_URL}/${profileId}/recalculateEmployeeRanks`);

/**
 * @param {string} profileId
 * @param {number[]} employeeIds
 * @returns {Promise<ApiManager.GetManagementInfosResponse>}
 */
export const approveBids = (profileId, employeeIds) => api.post(`${API_URL}/${profileId}/approve`, { employeeIds });

/**
 * @param {string} profileId
 * @param {number[]} employeeIds
 * @returns {Promise<ApiManager.GetManagementInfosResponse>}
 */
export const refuseBids = (profileId, employeeIds) => api.post(`${API_URL}/${profileId}/refuse`, { employeeIds });

/**
 * @param {string} profileId
 * @returns {Promise<import('axios').AxiosResponse<any>>}
 */
export const deleteBidProfile = (profileId) => api.delete(`${API_URL}/${profileId}`);

/**
 * @param {string} profileId
 * @returns {Promise<import('axios').AxiosResponse<any>>}
 */
export const archiveBidProfile = (profileId) => api.post(`${API_URL}/${profileId}/Archive`);

/**
 * @param {string} profileId
 * @param {number} hyperfindId
 * @param {Date|null} startDate
 * @param {Date|null} endDate
 * @returns {Promise<ApiManager.DataviewResponse>}
 */
export const executeDataview = (profileId, hyperfindId, startDate, endDate) => api.post(`${API_URL}/${profileId}/dataview/execute`, { hyperfindId, startDate, endDate });

/**
 * @param {string} profileId
 * @returns {Promise<any>}
 */
export const DownloadExcelTemplate = (profileId) => {
    const configs = {
        headers: {
            'Content-Type': 'blob',
        },
        responseType: 'arraybuffer',
    };

    return api.get(`${API_URL}/${profileId}/DownloadExcelTemplate`, configs);
};

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetBidProfileResponse>}
*/
export const completeBid = (profileId) => api.post(`${API_URL}/${profileId}/publish`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.UpdatedBidProfileResponse>}
*/
export const cancelBid = (profileId) => api.post(`${API_URL}/${profileId}/cancel`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.UpdatedBidProfileResponse>}
*/
export const activateBid = (profileId) => api.post(`${API_URL}/${profileId}/activateBid`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.UpdatedBidProfileResponse>}
*/
export const closeBid = (profileId) => api.post(`${API_URL}/${profileId}/closeBid`);

/**
 * @param {string} profileId
 * @param {ApiManager.EmployeeSchedulesBody} employeeScheduleBody
 * @returns {Promise<ApiManager.GetSequentialEmployeeScheduleResponse>}
 */
export const sequentialEmployeeSchedule = (profileId, employeeScheduleBody) => api.post(`${API_URL}/${profileId}/preview/sequentialEmployeeSchedule`, employeeScheduleBody);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetAwardingEmployeesProgressStatusQueryResponse>}
*/
export const getAwardingEmployeesProgressStatusQuery = (profileId) => api.get(`${API_URL}/${profileId}/awardingEmployees/status`);

/**
 * @param {string} profileId
 * @returns {Promise<ApiManager.GetImportProgressStatusQueryResponse>}
*/
export const getImportScheduleProgressStatusQuery = (profileId) => api.get(`${API_URL}/${profileId}/importSchedule/status`);
